const routes = [
  {
    path: '/google-reserve',
    name: 'google-reserve',
    component: () => import(/* webpackChunkName: "ReserveWithGooglePage" */ './views/ReserveWithGooglePage.vue'),
    meta: { pageNameEn: 'Reserve with Google' },
  },
];

export default routes;
